import { render, staticRenderFns } from "./Nbc.vue?vue&type=template&id=19ad917a&"
import script from "./Nbc.vue?vue&type=script&lang=js&"
export * from "./Nbc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports